
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ShowcaseSection extends Vue {
  @Prop({ default: 0 }) readonly currentSectionIndex!: number;
  @Prop({ default: null }) readonly dissolvingNextCtaIndex!: number | null;
  @Prop({ required: true }) readonly section4Screens!: number[];
  get section4LoopScreens(): Array<{ key: string; logicalIndex: number; screenNumber: number }> {
    const loopCopies = 3;
    const looped: Array<{ key: string; logicalIndex: number; screenNumber: number }> = [];
    for (let copyIndex = 0; copyIndex < loopCopies; copyIndex += 1) {
      this.section4Screens.forEach((screenNumber, logicalIndex) => {
        looped.push({
          key: `section4-loop-${copyIndex}-${logicalIndex}`,
          logicalIndex,
          screenNumber,
        });
      });
    }
    return looped;
  }
}
